import { injected } from "hooks/connectors";
import { useEagerConnect, useInactiveListener } from "hooks/Web3Hooks";
import React, { useEffect, useState } from "react";
import {
  ConnectedStatus,
  StyledConnectButton,
  StyledWrongNetwork,
} from "./styled";
import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React } from "@web3-react/core";
import { useCheckNetwork } from "hooks/CheckNetwork";
import { shortenAddr } from "utils/shortenAddr";

const ConnectButton = () => {
  const context = useWeb3React<Web3Provider>();
  const { connector, activate, account } = context;
  const { connected, correctNetwork } = useCheckNetwork();
  const [connectText, setConnectText] = useState(
    window.web3 && window.ethereum ? "Connect" : "Install Metamask"
  );
  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = useState<any>();
  useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [activatingConnector, connector]);

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect();

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector);
  useEffect(() => {}, []);

  const handleConnect = async () => {
    const connect = async () => {
      try {
        if (window.web3 && window.ethereum) await activate(injected);
        else window.open("https://metamask.io");
      } catch (e) {
        console.error(e);
      }
    };
    connect();
  };

  return (
    <>
      {correctNetwork.length > 0 ? (
        <StyledWrongNetwork disabled>{correctNetwork}</StyledWrongNetwork>
      ) : !connected ? (
        <StyledConnectButton id="connect-button" onClick={handleConnect}>
          {connectText}
        </StyledConnectButton>
      ) : (
        <ConnectedStatus>{shortenAddr(account ?? "")}</ConnectedStatus>
      )}
    </>
  );
};

export default ConnectButton;
